@if (show) {
<mat-form-field>
    <mat-label>Dealer</mat-label>
    <input #input type="text" matInput [formControl]="dealer" [matAutocomplete]="auto"
        (input)="filter()" (focus)="filter()">
    <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayWithFunc">
        @for (dealer of filteredDealers; track dealer) {
        <mat-option [value]="dealer">({{dealer.id | number:'5.0-0' | removeCommas}}) {{dealer.name}}</mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
}